import { ReactComponent as FilledIcon } from "../assets/icons/chats/heartFilled.svg";
import { ReactComponent as OutlineIcon } from "../assets/icons/chats/heartOutline.svg";
import genIcons from "./genIcons";

const Like = { Filled: genIcons(FilledIcon), Outline: genIcons(OutlineIcon, { htmlColor: "transparent" }) };

export default Like;
